import React from 'react';
import {
    Button,
    Form,
    Input,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider, Icon
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class OfferedAnswerQuestionCommentPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            showDeleteButton: this.props.showDeleteButton,
            admin: !!((localStorage.getItem('activeRole').startsWith('Administrator') || localStorage.getItem('activeRole').startsWith('QA admin:')))

        };
        this.setOptions = this.setOptions.bind(this);
    }

    componentDidMount() {

        //console.log('props opcija:' ,this.props.answerOptions);
        this.setOptions()
    }
    setOptions(){
        let options=[]
        for (let i =1 ; i<= 5; i=i+1 ){
            options.push(i)
        }
        this.setState({options})
    }



    handleChange = (e, { value }) => { //console.log('ovo saljem treba biti lista sa id: ',this.state.value, 'a profId :',this.props.staff );
        this.setState({ value },!this.state.admin ?
            ()=> {this.props.submitOfferedAnswerCommentQuestion(this.props.questionId,value,this.props.staff,this.props.typeName, this.state.comment)} :()=>{}
        )
    };
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        let question={
            text: this.props.text,
            answerOptions: this.props.answerOptions,
            typeId: this.props.typeId,
            typeName: this.props.typeName,
            //  answerOptions:[],
            questionId: this.props.questionId
        }

        return (

            <div>

                <Header as='h4'> <span style={{ color: 'red' }}>* &nbsp;</span>{question.text} {this.props.showDeleteButton && <Header as="h5" floated="right" ><span style={ {fontSize: '15px'} }>
                      <Icon name={'trash alternate'} link onClick={()=>{this.props.deleteQuestion(question.questionId)}} > </Icon>
                </span></Header>}</Header>
                <Form>
                    <Grid columns={2} centered stackable >

                        <Grid.Column width={16} stretched>

                            {  question.answerOptions.map((e)=>(
                                    <Form.Field>
                                        <Radio
                                            label={e.value}
                                            name="radioGroup"
                                            value= {e.id}
                                            checked={this.state.value === e.id}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Field>

                                )

                            )}


                        </Grid.Column>

                    </Grid>
                    <Form.Field >
                        <label>
                            {/* {<FormattedMessage id="common.notification" />} */}
                            Komentar
                        </label>
                        <FormattedMessage id="poll.placeholderComment">
                            {(msg) => (<textarea
                                required
                                fluid
                                placeholder={msg}
                                control={TextArea}
                                rows="4"
                                label="Komentar"
                                value={this.state.comment}
                                name="comment"
                                onChange={(e) => {if(!this.state.admin){this.props.updateQuestionComment(question.questionId,this.props.staff,e.target.value); this.setState({ comment: e.target.value })}}}
                            />)}
                        </FormattedMessage>
                    </Form.Field>
                </Form>


                {this.props.showDivider && <Divider/>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionPreviews/OfferedAnswerQuestionCommentPreview.js